const svg = `<svg width="31" height="30" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="Canvas" fill="none">
<g id="Subtract">
<path class='icon' d="M 0 15.0032C 0 10.5485 1.94147 6.54723 5.02443 3.79941L 10.2724 18.2182L 0.345267 18.2182C 0.119142 17.1825 0 16.1067 0 15.0032Z" fill="#30353F"/>
<path class='icon' d="M 2.00716 22.5048C 4.53214 26.8697 9.19303 29.8445 14.5607 30L 11.8326 22.5048L 2.00716 22.5048Z" fill="#30353F"/>
<path class='icon' d="M 19.2898 29.3851C 19.1722 29.4201 19.054 29.4537 18.9353 29.4859L 8.70612 1.38149C 10.621 0.494805 12.7543 0 15.0032 0C 16.4927 0 17.9316 0.21707 19.2898 0.621301L 19.2898 29.3851Z" fill="#30353F"/>
<path class='icon' d="M 24.6481 26.4959C 27.9241 23.7437 30.0064 19.6166 30.0064 15.0032C 30.0064 10.3898 27.9241 6.26267 24.6481 3.5105L 24.6481 26.4959Z" fill="#30353F"/>
</g>
</g>
</svg>`;

export default svg;

